if (!window.hasInitializedScrollingBands) {
  window.hasInitializedScrollingBands = true;

  let scrollingBands = document.querySelectorAll('.scrolling-band__slider');

  scrollingBands.forEach((scrollingBand) => {
    const scrollingBandsItemsContainer = scrollingBand.querySelector('.scrolling-band__items');
    const directChildren = scrollingBandsItemsContainer.children;

    for (let i = 0; i < directChildren.length; i++) {
      directChildren[i].classList.add('item');
    }

    const scrollingBandsItems = scrollingBand.querySelectorAll('.item');
    const scrollingBandSpeed = parseInt(scrollingBand.getAttribute('data-scrolling-speed'), 10) || 20;
    const imagesPerView = parseInt(scrollingBand.getAttribute('data-images-per-view'), 10) || 7;

    if (scrollingBandsItems.length > 0) {
      // Clone multiple times to ensure continuous scrolling
      const duplicationCount = 10; // Clone 5 times
      const originalItems = Array.from(scrollingBandsItems);

      // Clone items multiple times
      for (let i = 0; i < duplicationCount; i++) {
        originalItems.forEach((initialItem) => {
          const clonedItem = initialItem.cloneNode(true);
          scrollingBandsItemsContainer.appendChild(clonedItem);
        });
      }

      // Add more clones at the end for smoother transitions
      originalItems.forEach((initialItem) => {
        const clonedItem = initialItem.cloneNode(true);
        scrollingBandsItemsContainer.appendChild(clonedItem);
      });
    }

    let transformScrolling = 0;

    function updateScroll() {
      transformScrolling -= 1;

      // Reset when we've scrolled through all items
      if (Math.abs(transformScrolling) >= scrollingBandsItemsContainer.scrollWidth) {
        transformScrolling = 0;
      }

      scrollingBandsItemsContainer.style.transform = `translateX(${transformScrolling}px)`;
    }

    setInterval(updateScroll, scrollingBandSpeed);
  });
}